module.exports = __webpack_public_path__ + "img/newAdd.64b13a87.png";